import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./app/config/reportWebVitals";
import * as Sentry from "@sentry/react";
import "./app/config/sentry";
import App from "./app";

const rootElement = document.getElementById("root");
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <Sentry.ErrorBoundary
      fallback={<p>Algo deu errado, reinicie a aplicação!</p>}
    >
      <App />
    </Sentry.ErrorBoundary>
  );
} else {
  console.error('Elemento com ID "root" não encontrado.');
}

reportWebVitals(Sentry.captureException);